import { Button } from "@swot/base-components";
import { CmtsEnterpriseModal } from "./CmtsEnterpriseModal.js";

export function CmtsDeleteDeactivateDialog({
  open,
  title = "Confirm destructive action",
  message = "Backend dependency checks must pass before this action can continue.",
  busy = false,
  onConfirm,
  onCancel,
}: {
  readonly open: boolean;
  readonly title?: string | undefined;
  readonly message?: string | undefined;
  readonly busy?: boolean | undefined;
  readonly onConfirm: () => void | Promise<void>;
  readonly onCancel: () => void;
}) {
  return (
    <CmtsEnterpriseModal
      open={open}
      title={title}
      subtitle="This action is permission and dependency controlled."
      size="sm"
      onClose={onCancel}
      footer={
        <>
          <Button label="Cancel" variant="secondary" disabled={busy} onClick={onCancel} />
          <Button label={busy ? "Working..." : "Confirm"} variant="danger" loading={busy} disabled={busy} onClick={onConfirm} />
        </>
      }
    >
      <p className="cmts-confirmation-message">{message}</p>
    </CmtsEnterpriseModal>
  );
}
